//#region types
import { DateHelper } from "utils/helpers";
//#endregion
//#region components
//#endregion

function useTimeReportingHelpers() {
  const today = new Date();

  const isMemberActive = (
    projectStartDate: Date,
    projectEndDate?: Date,
    memberStartDate?: Date,
    memberEndDate?: Date
  ) =>
    DateHelper.withinIntervall(today, projectStartDate as Date, projectEndDate as Date) &&
    DateHelper.withinIntervall(today, memberStartDate as Date, memberEndDate as Date);

  return { isMemberActive };
}

export default useTimeReportingHelpers;
